export enum ItemUpdateTarget_Enum {
  ItemMaster = 1,
  IDIItemSource = 2
}
